import React, { FC, useState, useContext } from 'react';
import injectSheet from 'react-jss';
import { Input } from 'Components/Inputs';
import { ProductAnalyticsContext } from 'Context/ProductAnalytics';
import { useRouter } from 'Utils/router';
import styleSheet from './styles';
import { Button } from '../../Buttons';

interface Props {
  classes?: any;
  onCancel?: () => void;
  onCreate?: (name: string) => void;
  closeModal?: () => void;
  errorMessage?: string;
  disabled: boolean;
  checkedItems?: number;
}

const NewList: FC<Props> = (props: Props) => {
  const [textInput, setTextInput] = useState('');
  const {
    classes = {},
    onCancel: propOnCancel,
    onCreate: proponCreate,
    closeModal,
    errorMessage,
    disabled,
    checkedItems = 0, // Set a default, as checkedItems may not be passed in
  } = props;
  const {
    helpers: {
      View,
      selectedFilters,
      metrics: { store: metricsStore },
    },
    actions: { track },
  } = useContext(ProductAnalyticsContext);
  const { location } = useRouter();
  const [time] = useState(new Date().getTime());

  const onCreate = () => {
    // Combined Analytics event tracking
    const { listTotalCount }: any = metricsStore;
    track('add_to_list_submitted', {
      screen: View(location.pathname),
      scope: checkedItems === 0 ? 'All' : 'Selected',
      existing_list_count: listTotalCount, // This is the number of lists created by a user
      new_list_created: true, // This is an existing list.
      time_spent: `${Math.abs((new Date().getTime() - time) / 1000)} sec`, // Convert the milliseconds to seconds
      filters_selected: selectedFilters().join(','),
    });

    // Combined Analytics event tracking
    track('create_new_tab_viewed', {
      screen: View(location.pathname),
      scope: checkedItems === 0 ? 'All' : 'Selected',
      existing_list_count: listTotalCount, // This is the number of lists created by a user
    });

    if (proponCreate && proponCreate) proponCreate(textInput);
  };
  const onCancel = () => {
    // Combined Analytics event tracking
    const { listTotalCount }: any = metricsStore;
    track('add_to_list_cancelled', {
      screen: View(location.pathname),
      scope: checkedItems === 0 ? 'All' : 'Selected',
      existing_list_count: listTotalCount,
    });

    if (propOnCancel && propOnCancel) propOnCancel();
    if (closeModal && closeModal) closeModal();
  };

  return (
    <div className={classes.container}>
      <div style={{ position: 'relative' }}>
        <Input
          type="text"
          name="New List"
          placeholder="New list name"
          onChange={(e: any) => setTextInput(e.target.value)}
          limitCharacterText="100 characters max"
          maxLength={100}
          textInput={textInput}
          overrideStyles={{
            height: '60px',
            borderRadius: '4px',
            border: '1.2px solid #D8DCE6',
            padding: '0 25px',
            color: '051D39',
          }}
          ariaLabel="Enter new list name"
        />
      </div>
      {errorMessage && <div className={classes.error}>{errorMessage}</div>}
      <div className={classes.controls}>
        <Button onClick={onCancel} buttonType="defaultClear">
          Cancel
        </Button>
        <Button
          disabled={textInput.length < 1 || disabled}
          onClick={onCreate}
          buttonType="defaultBlue"
        >
          Add to List
        </Button>
      </div>
    </div>
  );
};

NewList.defaultProps = {
  classes: {},
  errorMessage: '',
  // disabled: false,
  checkedItems: 0,
  onCancel: () => {},
  onCreate: () => {},
  closeModal: () => {},
};

export default injectSheet(styleSheet)(NewList);
